import React from 'react';

import { textControlsBlock as block } from '../utils';

interface TextControlProps {
  children: React.ReactNode;
  icon: React.ReactNode;
  label: string;
  layout: 'horizontal' | 'vertical';
}

const TextControl: React.FunctionComponent<TextControlProps> = props => {
  const { children, icon, label, layout } = props;

  return (
    <div className={block('control-row')}>
      <div className={block('icon-wrapper')}>{icon}</div>
      <div className={block('control-container', { [layout]: true })}>
        <h5>{label}</h5>
        {children}
      </div>
    </div>
  );
};

export default TextControl;
